// ProcessingComparison.jsx
import React from "react";
import "../css/ProcessingComparison.css";
import ProcessingComparison from "../../assets/compare-devices-01.png";
import croppedLogo from "../../assets/cropped-merchant-marvels.jpg";

/**
 * Usage:
 * <ProcessingComparison centerImageSrc="/images/device.png" />
 */
export default function LandingProcessingComparison({
    title = "We change the way you get paid",
    description = `With recent law changes and the advancement of our proprietary software your business can now
accept credit cards for FREE! Merchant Marvels Introduces 0% Processing! It is a method of passing a service fee to
all customers while giving a discount to those who pay with cash.`,
    leftTitle = "Traditional Processing",
    rightTitle = `Merchant Marvels\n0% Processing`,
}) {
    return (
        <section className="pc" aria-label="Processing comparison">
            {/* subtle top notch like the screenshot */}
            <div className="pc__topNotch" aria-hidden="true" />

            <div className="pc__inner">
                <header className="pc__header">
                    <h2 className="pc__title">{title}</h2>
                    <p className="pc__desc">{description}</p>
                </header>

                <div className="pc__grid">
                    {/* LEFT */}
                    <div className="pc__col pc__col--left">
                        <div className="pc__colHead">
                            <h3 className="pc__colTitle">{leftTitle}</h3>
                            <span className="pc__flag" aria-hidden="true" />
                        </div>

                        <ul className="pc__list pc__list--left">
                            <li className="pc__item">
                                <div className="pc__itemMain">Credit/Debit Card</div>
                            </li>

                            <li className="pc__item">
                                <div className="pc__itemMain">Payment Terminal</div>
                                <div className="pc__itemSub">Charges 2.7%-3.5% processing fee</div>
                            </li>

                            <li className="pc__item">
                                <div className="pc__itemMain">Customer</div>
                                <div className="pc__itemSub">Pays no fee.</div>
                                <div className="pc__itemSub">Gets rewards points</div>
                            </li>

                            <li className="pc__item">
                                <div className="pc__itemMain">Merchant</div>
                                <div className="pc__itemSub">Receives 96% of sale amount</div>
                            </li>

                            {/* vertical guide line + dots */}
                            <span className="pc__vline pc__vline--left" aria-hidden="true" />
                        </ul>
                    </div>

                    {/* CENTER */}
                    <div className="pc__center">
                        <div className="pc__deviceWrap">
                            <span className="pc__centerDivider" aria-hidden="true" />
                            <img className="pc__device" src={ProcessingComparison} alt="Payment terminal" />
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="pc__col pc__col--right">
                        <div className="pc__colHead pc__colHead--right">
                            {/* <span className="pc__brandDot" aria-hidden="true" /> */}
                            <img className="pc__brandImg" src={croppedLogo} alt="logo" />
                            <h3 className="pc__colTitle pc__colTitle--right">{rightTitle}</h3>
                        </div>

                        <ul className="pc__list pc__list--right">
                            <li className="pc__item pc__item--right">
                                <div className="pc__itemMain">Credit/Debit Card</div>
                            </li>

                            <li className="pc__item pc__item--right">
                                <div className="pc__itemMain">Payment Terminal</div>
                                <div className="pc__itemSub">Auto-calculates</div>
                                <div className="pc__itemSub">3.99% fee</div>
                            </li>

                            <li className="pc__item pc__item--right">
                                <div className="pc__itemMain">Customer</div>
                                <div className="pc__itemSub">Pays small fee.</div>
                                <div className="pc__itemSub">Still gets rewards points</div>
                            </li>

                            <li className="pc__item pc__item--right">
                                <div className="pc__itemMain">Merchant</div>
                                <div className="pc__itemSub">
                                    <span className="pc__accent">Receives 100%</span> of sale amount
                                </div>
                            </li>

                            {/* vertical guide line + dots */}
                            <span className="pc__vline pc__vline--right" aria-hidden="true" />
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}